var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flash-message',{staticClass:"flashpool",attrs:{"transition-name":"flash"}})
}
var staticRenderFns = []

export { render, staticRenderFns }